import React from 'react';
import Fader from 'react-fader';
import { Route, Redirect } from 'react-router-dom';
import Switch from 'react-router-transition-switch';

import ApplicationLayout from 'components/ApplicationLayout';
import useIsMobile from 'hooks/useIsMobile';
import GuestNotAuthorized from 'screens/components/Login/forms/GuestNotAuthorized';
import Root from 'screens/components/Root';
import InviteContainer from 'screens/containers/Invite';
import Login from 'screens/containers/Login';
import LoginEmail from 'screens/containers/LoginEmail';
import OAuthDefaultContainer from 'screens/containers/OAuthDefaultContainer';
import RegistrationOnboardingContainer from 'screens/containers/RegistrationOnboarding';
import TravelerProfile from 'screens/containers/TravelerProfile';

const PublicRouter = () => {
  const isMobile = useIsMobile();

  return (
    <Switch
      render={({ children }) => (
        <ApplicationLayout>
          <Fader viewStyle={isMobile ? { height: '100vh' } : {}}>{children}</Fader>
        </ApplicationLayout>
      )}
    >
      <Route path="/invite" component={InviteContainer} />
      <Route path="/registration" component={RegistrationOnboardingContainer} />
      <Route exact path="/login-email" component={LoginEmail} />
      <Route path="/login" component={Login} />
      <Route exact path="/travelerProfile" component={TravelerProfile} />
      <Route exact path="/" component={Root} />
      <Route exact path="/oauth-login" component={OAuthDefaultContainer} />
      <Route exact path="/oauth-registration" component={OAuthDefaultContainer} />
      <Route exact path="/oauth-invite" component={OAuthDefaultContainer} />
      <Route exact path="/login-not-authorized" component={GuestNotAuthorized} />
      <Redirect to="/" />
    </Switch>
  );
};

export default PublicRouter;
